import React, { useState, useEffect } from 'react';
import { Card, Button, InputNumber, Space, Progress, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { socket } from '../socket';

const { Text } = Typography;

function SessionTimer({ isCreator }) {
  const [minutes, setMinutes] = useState(5);
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [totalSeconds, setTotalSeconds] = useState(5 * 60);
  const [remainingSeconds, setRemainingSeconds] = useState(5 * 60);

  useEffect(() => {
    socket.on('timerSet', (timer) => {
      const remaining = Math.max(0, Math.floor((timer.startTime + timer.duration - Date.now()) / 1000));
      setTotalSeconds(timer.duration / 1000);
      setRemainingSeconds(remaining);
      setMinutes(Math.floor(remaining / 60));
      setSeconds(remaining % 60);
      setIsRunning(true);
    });

    return () => {
      socket.off('timerSet');
    };
  }, []);

  useEffect(() => {
    let interval;
    if (isRunning && remainingSeconds > 0) {
      interval = setInterval(() => {
        const newRemaining = remainingSeconds - 1;
        setRemainingSeconds(newRemaining);
        setMinutes(Math.floor(newRemaining / 60));
        setSeconds(newRemaining % 60);
      }, 1000);
    } else if (remainingSeconds === 0) {
      setIsRunning(false);
    }
    return () => clearInterval(interval);
  }, [isRunning, remainingSeconds]);

  const startTimer = () => {
    if (isCreator) {
      socket.emit('setTimer', { 
        channelId: socket.channelId, 
        duration: totalSeconds 
      });
    }
  };

  const setCustomMinutes = (value) => {
    if (isCreator) {
      const newTotalSeconds = value * 60;
      setTotalSeconds(newTotalSeconds);
      setRemainingSeconds(newTotalSeconds);
      setMinutes(value);
      setSeconds(0);
    }
  };

  const progress = (remainingSeconds / totalSeconds) * 100;

  return (
    <Card title={<Space><ClockCircleOutlined /> Session Timer</Space>}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center' }}>
          <Text style={{ fontSize: 24 }}>
            {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
          </Text>
        </div>
        
        <Progress 
          percent={progress} 
          showInfo={false}
          status={remainingSeconds < 30 ? "exception" : "active"}
        />

        {isCreator && (
          <Space wrap>
            <InputNumber
              min={1}
              max={60}
              value={Math.floor(totalSeconds / 60)}
              onChange={setCustomMinutes}
              disabled={isRunning}
              style={{ width: 80 }}
            />
            <Button 
              type="primary"
              onClick={startTimer}
              disabled={isRunning}
            >
              Start Timer
            </Button>
          </Space>
        )}
      </Space>
    </Card>
  );
}

export default SessionTimer; 